import axios, { AxiosInstance } from 'axios'
import baseConfig from './clientShared'

const webCachedClient = axios.create({
    ...baseConfig,
    baseURL: '/ajax/',
})

// @see: websrc/src/api/client.ts
export const cachedClient =
    process.env.CONFIG_KEY !== 'mobile'
        ? webCachedClient
        : (require('@/mobile/src/api/mobileclient').ajaxClient as AxiosInstance)
export const ajaxClient =
    process.env.CONFIG_KEY !== 'mobile'
        ? cachedClient
        : (require('@/mobile/src/api/mobileclient').ajaxClient as AxiosInstance)
export const publicClient =
    process.env.CONFIG_KEY !== 'mobile'
        ? cachedClient
        : (require('@/mobile/src/api/mobileclient').jsonClient as AxiosInstance)
export const formClient =
    process.env.CONFIG_KEY !== 'mobile'
        ? cachedClient
        : (require('@/mobile/src/api/mobileclient').formClient as AxiosInstance)

const client = ajaxClient
export default client
